import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export function AuthorName({ name, link, withMetadata, className }) {
  return name === 'Edmunds' || !link ? (
    <span {...withMetadata && { itemProp: 'author' }} className="fw-bold text-capitalize align-baseline">
      {name}
    </span>
  ) : (
    <span {...withMetadata && { itemScope: true, itemProp: 'author', itemType: 'https://schema.org/Person' }}>
      <a className={classnames('btn btn-link text-capitalize align-baseline', className)} href={link}>
        {withMetadata && <meta itemProp="url" content={`https://www.edmunds.com${link}`} />}
        <span {...withMetadata && { itemProp: 'name' }}>{name}</span>
      </a>
    </span>
  );
}

AuthorName.propTypes = {
  name: PropTypes.string,
  link: PropTypes.string,
  withMetadata: PropTypes.bool,
  className: PropTypes.string,
};

AuthorName.defaultProps = {
  name: null,
  link: null,
  withMetadata: true,
  className: 'btn-sm',
};
